<template>
  <h2>行业研究咨询报告</h2>
  <h3 class="form-title" style="color: red;">产业洞察研究，受到广大客户的信任并长期使用</h3>
  <div>
    <ul>
      <li>如何快速了解各行业的最新状况？</li>
      <li>打算寻找目标客户或合作伙伴却无从下手吗？</li>
      <li>没有太多的预算进行广泛的市场调查？</li>
      <li>如何洞察商业模式和把握价值链？</li>
      <li>如何理解监管并用好政策？</li>
      <li>如何在竞争中把握先机并提前识别风险？</li>
      <li>如何预见产业未来在5到10年领导先机提前布局？</li>
    </ul>
  </div>
  <div class="paragraph">
    丰富的专家资源和信息资源： GICS全行业覆盖和绝大多数战略性新产业和主题产业领域。范围广、针对性强：内容全面、论述生动；深入的洞察力和预见力：有创造力和建设意义的对策建议。核心合伙人分别来自于国家经济研究部门、顶级咨询公司、一流投资机构和世界500强企业。
  </div>
  <div class="img-row">
    <img :src="require('/src/assets/images/industryBG.png')" alt="">
  </div>

  <div class="paragraph">
    提供word报告和PPT版本以及EXCEL工作底稿。每份定价50000元，如果行业复杂难度大，会酌情增加收费。
  </div>
  <div class="img-row">
    <img :src="require('/src/assets/images/industryBG2.png')" alt="">
  </div>
  <div>
    联系方式:
    <ul>
      <li>电话：021-68828928, 15216609136</li>
      <li>E-mail：duanshihua@foxmail.com, 3450306099@qq.com</li>
      <li>QQ：3450306099, 2985437939</li>
      <li>微信：ksqj08, duanshihuaweixin</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "IndustryTable",
  data() {
    return {};
  },
  components: {},
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.img-row {
  text-align: center;
  margin: 10px auto 10px auto;
  img {
    max-width: 95%;
  }
}
</style>
